var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdentity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_258_22371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 16.1667C15.1278 16.1667 16.0903 15.7681 16.8875 14.9708C17.6847 14.1736 18.0833 13.2111 18.0833 12.0833C18.0833 10.9556 17.6847 9.99306 16.8875 9.19583C16.0903 8.39861 15.1278 8 14 8C12.8722 8 11.9097 8.39861 11.1125 9.19583C10.3153 9.99306 9.91667 10.9556 9.91667 12.0833C9.91667 13.2111 10.3153 14.1736 11.1125 14.9708C11.9097 15.7681 12.8722 16.1667 14 16.1667ZM14 27.25L3.5 20.8333V9.16667L14 2.75L24.5 9.16667V20.8333L14 27.25ZM14 24.5083L20.5333 20.5125C19.6 19.8708 18.5842 19.375 17.486 19.025C16.387 18.675 15.225 18.5 14 18.5C12.775 18.5 11.6134 18.675 10.5152 19.025C9.41617 19.375 8.4 19.8708 7.46667 20.5125L14 24.5083Z",
    fill: "#73199D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_258_22371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.348999 0.707336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentity);
export default __webpack_public_path__ + "static/media/identity.bd13f8f12030871a47080344bdc3e1ae.svg";
export { ForwardRef as ReactComponent };